import * as CL from '@design-system/component-library';
import { Link } from 'react-router';
import { paths } from '../../common/constants/pathVariables';
import { closeMsg, invitationsPageMsg, t } from '../../common/i18n';

export const InvitationRequiredModal = ({ onClose }: { onClose: () => void }) => (
  <CL.Modal
    heading={t.FTAF('Invite cannot be sent')}
    content={
      <>
        {t.VMZW('You must send an invite to the employee in OmaElisa via the ')}
        <Link to={paths.COMPANY_INFO_INVITES}>{t.WM9Y(invitationsPageMsg)}</Link>
        {t.IMN8(' before granting the order approver role.')}
      </>
    }
    buttons={[
      <CL.Button key="close" color="primary" onClick={onClose}>
        {t.WOYD(closeMsg)}
      </CL.Button>,
    ]}
    onModalClose={onClose}
    autoOpen
  />
);
